export const isContentNotEmpty = (str: string) => {
  if (str === null || str === '') {
    return false;
  }
  const cleanValue = str.replace(/(<([^>]+)>)|\s/gi, '');

  return cleanValue.length > 0;
};
